import DrillingPump from './DrillingPump';

export default DrillingPump;



// WEBPACK FOOTER //
// ./src/Components/Main/TestWorkflow/DrillingPump/index.tsx